import PromotionCard from 'pages/PromotionPage/PromotionCardsContainer/PromotionCard/PromotionCard';

export default PromotionCard;
